import { computed } from "vue";
import useScreenSize from "./screenSize";


export default function useIsMobile(widthBreakpoint = 768) {
  const screenSize = useScreenSize();
  const isMobile = computed(() => (screenSize.width.value < widthBreakpoint));
  return isMobile;
}